export default "__VITE_ASSET__DcZE24lQ__"